// src/index.tsx
import './consoleOverride';
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ContextProvider } from "./contextApi/contextProvider";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { startPrefetchWarmup } from "./utils/prefetchWarmup";
import { CACHE_VERSION } from "./utils/version";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <BrowserRouter>
    <ContextProvider>
      <App />
    </ContextProvider>
  </BrowserRouter>
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    // Register the prefetch SW — pass the current cache version so the
    // service worker clears stale caches on every deploy.
    navigator.serviceWorker
      .register("/sw-prefetch.js", { updateViaCache: "none" })
      .then((registration) => {
        registration.update();
        // Notify the SW of the current cache version (auto-versioning)
        if (registration.active) {
          registration.active.postMessage({
            type: "SET_CACHE_VERSION",
            version: CACHE_VERSION,
          });
        }
      })
      .catch(() => {
        // ignore registration failures
      });
  });
}

startPrefetchWarmup();

// Suppress output from reportWebVitals
reportWebVitals(() => {});
